import React from 'react'
import { Button } from 'reactstrap'

export default function TranscriptNewButton({handleClick}) {
  return (
    <Button size="sm" color="primary" onClick={handleClick}>Choose a transcript</Button>
  )
}
